var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable } from 'mobx';
import CSVParser from 'papaparse';
import ReportDataHeaderModel from "./ReportDataHeaderModel";
/**
 *
 */
var ReportDataModel = /** @class */ (function () {
    /**
     *
     * @param csvString
     */
    function ReportDataModel(csvString) {
        if (csvString === void 0) { csvString = null; }
        this.data = [];
        this.errors = [];
        this.meta = {};
        this.update(csvString);
    }
    /**
     *
     * @param csvString
     */
    ReportDataModel.prototype.update = function (csvString) {
        if (!csvString)
            return;
        //https://www.papaparse.com/docs#config
        var parsedData = CSVParser.parse(csvString, { header: false, skipEmptyLines: true });
        //https://www.papaparse.com/docs#results
        this.data = parsedData.data;
        this.errors = parsedData.errors;
        this.meta = parsedData.meta;
        this.csvString = csvString;
    };
    ReportDataModel.prototype.getHeaders = function (columns) {
        if (columns === void 0) { columns = null; }
        if (!this.data || this.data.length == 0) {
            return [];
        }
        var headers = this.data[0];
        return headers.map(function (value) {
            var chunks = value.split('@');
            var name = chunks[0];
            var type = chunks[1];
            if (columns && columns[name]) {
                console.log('\thidden', columns[name].type === 'hidden');
            }
            var hidden = columns && columns[name] && columns[name].type === 'hidden';
            return new ReportDataHeaderModel({ name: name, type: type, hidden: hidden });
        });
    };
    ReportDataModel.prototype.getBody = function () {
        var data = this.data.concat([]);
        data.shift();
        return data;
    };
    ReportDataModel.prototype.getExportData = function (reportModel, intl) {
        var headers = this.getHeaders(reportModel.columns);
        var body = this.getBody();
        var result = [];
        result = [headers.map(function (reportDataHeaderModel) {
                return !reportDataHeaderModel.hidden ? intl.formatMessage({ id: 'reports.table.columns.header.' + reportDataHeaderModel.name }) : null;
            }).filter(function (value) { return value !== null; })];
        result = result.concat(body.map(function (row, index) {
            return row.map(function (columnValue, index) {
                return !headers[index].hidden ? columnValue : null;
            }).filter(function (value) { return value !== null; });
        }));
        return result;
    };
    __decorate([
        observable
    ], ReportDataModel.prototype, "data", void 0);
    __decorate([
        observable
    ], ReportDataModel.prototype, "errors", void 0);
    __decorate([
        observable
    ], ReportDataModel.prototype, "meta", void 0);
    __decorate([
        observable
    ], ReportDataModel.prototype, "csvString", void 0);
    return ReportDataModel;
}());
export default ReportDataModel;
